import { render, staticRenderFns } from "./TransactionSuccess.vue?vue&type=template&id=8f6415c2&scoped=true"
import script from "./TransactionSuccess.vue?vue&type=script&lang=js"
export * from "./TransactionSuccess.vue?vue&type=script&lang=js"
import style0 from "./TransactionSuccess.vue?vue&type=style&index=0&id=8f6415c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6415c2",
  null
  
)

export default component.exports